module.exports = __webpack_public_path__ + "img/czech-republic.a4146fd3.png";